import React, { useState, useEffect } from 'react';
import { useTheme } from "@mui/material/styles";

// Component
import ModalContainer from "components/ModalContainer";
import LandingView from "./LandingView";
import MainView from "./MainView";

// Const

// Util

const viewStateEnum = {
  LANDING: "landing",
  MAIN: "main",
  UPLOAD: "upload",
  IMPORT: "import",
  ADOPT: "adopt",
};

const viewStateWidthEnum = {
  [viewStateEnum.LANDING]: "850px",
  [viewStateEnum.MAIN]: "auto",
  [viewStateEnum.UPLOAD]: "auto",
  [viewStateEnum.IMPORT]: "auto",
  [viewStateEnum.ADOPT]: "auto",
};

const getViewStateTitle = (view) => {
  switch (view) {
    case viewStateEnum.LANDING:
      return "Add Device By Zero Touch Provisioning";
    case viewStateEnum.MAIN:
      return "Device Adoption";
    case viewStateEnum.UPLOAD:
      return "Add MAC-Address by Upload";
    case viewStateEnum.IMPORT:
      return "Import MAC Address List";
    case viewStateEnum.ADOPT:
      return "Device Adoption";
    default:
      return "";
  }
};

const getModalWidthByViewState = (view) => {
  return viewStateWidthEnum[view] || "600px";
}

const ModalPreRegister = ({
  auth,
  openModal,
  onCloseModal,
}) => {
  const theme = useTheme();

  // State
  const [viewState, setViewState] = useState(viewStateEnum.LANDING);
  const [showPreConfirm, setShowPreConfirm] = useState(false);

  // Method
  const init = () => { }

  const handleCloseModal = () => {
    setViewState(viewStateEnum.LANDING);
    setShowPreConfirm(false);
    onCloseModal();
  }

  const changeViewState = (newState) => {
    setViewState(newState);
  }

  const getViewTitle = (view) => {
    return getViewStateTitle(view);
  }

  // Side effect
  useEffect(() => {
    if (openModal) {
      init();
    }
  }, [openModal]);

  if (!openModal) {
    return null;
  }

  return (
    <>
      <ModalContainer
        display={openModal}
        modalWidth={showPreConfirm ? "600px" : getModalWidthByViewState(viewState)}
      >
        {viewState === viewStateEnum.LANDING ? (
          <LandingView
            viewStateEnum={viewStateEnum}
            getViewTitle={getViewTitle}
            viewState={viewState}
            changeViewState={changeViewState}
            onCloseModal={handleCloseModal}
          />
        ) : (
          <>
            <MainView
              auth={auth}
              viewStateEnum={viewStateEnum}
              getViewTitle={getViewTitle}
              viewState={viewState}
              changeViewState={changeViewState}
              onCloseModal={handleCloseModal}
              setShowPreConfirm={setShowPreConfirm}
            />
          </>
        )}
      </ModalContainer>
    </>
  );
}

export default ModalPreRegister;
